<template>
  <div class="modal overflow-auto" select-cy="update-supporter-details">
    <div class="card inner">
      <div class="header">
        <div class="title">
          <h2>Edit General Information</h2>
        </div>
        <div class="close" @click="close()">
          <i class="icn icn-x sm"></i>
        </div>
      </div>
      <div class="content">
        <form id="supporter-edit" @submit.prevent @submit="edit">
          <h3 class="sub-title">Details</h3>
          <div class="row mt-2">
            <div class="field">
              <select required v-model="editItem.title">
                <option :value="t" :selected="t === editItem.title" v-for="t of titles" :key="t">
                  {{ t }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="field">
              <input
                required
                v-model="editItem.firstName"
                type="text"
                placeholder="First name"
                maxlength="127"
                autocomplete="nope"
                data-cy="first"
              />
            </div>
            <div class="field">
              <input
                required
                v-model="editItem.lastName"
                type="text"
                placeholder="Last name"
                maxlength="127"
                autocomplete="nope"
                data-cy="last"
              />
            </div>
          </div>
        </form>
      </div>

      <!-- Error Messages -->
      <Alert v-if="errorMessage" :message="errorMessage"></Alert>

      <div class="footer">
        <button class="secondary" type="button" @click="close()">Cancel</button>
        <div class="flex-grow"></div>
        <button type="button" @click="edit()" :disabled="!canSubmit" select-cy="submit-edit-supporter">
          <span v-if="!isValidating">Save</span>
          <span class="icon" v-if="isValidating">
            <i class="icn icn-refresh sm animate-reverse-spin"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ALERT_TYPE, MESSAGES, SUPPORTER_TITLE, CONTACT_TYPE } from '@/helpers/constants';
import { MODAL_NAME } from '../../stores/supporters';
import Alert from '@/components/Alert.vue';

export default {
  name: 'SupporterEditDetails',
  components: {
    Alert,
  },

  data() {
    return {
      editItem: {
        id: null,
        title: null,
        fisrtName: null,
        lastName: null,
      },
      isValidating: false,
      isProcessing: false,
      message: null,
    };
  },
  props: {
    supporter: Object,
  },
  computed: {
    item() {
      return this.$store.getters['supporters/getSupporter'];
    },
    canSubmit() {
      return !this.isProcessing;
    },
    titles() {
      return Object.values(SUPPORTER_TITLE);
    },
    errorMessage: {
      get() {
        return this.message;
      },
      set(value) {
        if (value === null) {
          this.message = null;
        } else {
          this.message = {
            content: value,
            type: ALERT_TYPE.ERROR,
          };
        }
      },
    },
  },

  created() {
    // this.editItem = { ...this.item };
    this.editItem = { ...this.supporter };
  },

  methods: {
    close() {
      this.$store.commit('supporters/close', MODAL_NAME.EDIT_DETAILS);
    },
    edit() {
      if (this.isValidating) return;
      this.errorMessage = null;
      this.isValidating = true;
      const isValid = document.querySelector('#supporter-edit').reportValidity();
      if (isValid) {
        if (this.isChanged()) {
          // Create update details for WWF people to update to RE
          if (this.supporter.reConstituentId) {
            this.createUpdateDetails(this.editItem);
          }

          // Send to Pandata
          this.$store
            .dispatch('supporters/edit', [this.editItem])
            .then(() => {
              this.$store.commit('supporters/refresh');
              this.close();
            })
            .catch(err => {
              console.error(err);
              if (err && err.status && err.status === 401) {
                this.errorMessage = MESSAGES.NO_PERMISSION;
              } else {
                this.errorMessage = MESSAGES.SERVER_ERROR;
              }
            })
            .finally(() => (this.isValidating = false));
        } else {
          this.close();
          this.isValidating = false;
        }
      } else {
        this.isValidating = false;
      }
    },
    isChanged() {
      return (
        this.supporter.firstName !== this.editItem.firstName ||
        this.supporter.lastName !== this.editItem.lastName ||
        this.supporter.title !== this.editItem.title
      );
    },
    createUpdateDetails(data) {
      const payload = {
        supporterId: this.supporter.id,
        email: this.supporter.contacts
          .filter(contact => contact.type === CONTACT_TYPE.EMAIL)
          .sort((a, b) => (b.isPrimary ? 1 : -1))[0]?.contact,
        reConstituentId: this.supporter.reConstituentId,
        firatName: data.firstName,
        lastName: data.lastName,
        createdAt: new Date(),
        title: data.title,
      };

      this.$store
        .dispatch('supporters/createUpdateDetails', [payload])
        .then(() => {
          this.$store.dispatch('notifications/success', {
            headline: 'Contact Details Updated',
            details: 'The request has been submitted.',
          });
          this.close();
        })
        .catch(err => {
          console.error(err);
          if (err && err.status && err.status === 401) {
            this.errorMessage = MESSAGES.NO_PERMISSION;
          } else {
            this.errorMessage = MESSAGES.SERVER_ERROR;
          }
        })
        .finally(() => (this.isValidating = false));
    },
  },
};
</script>
